const createQuery = () => `
  ... on LatestMagazineIssueWidget {
    magazineIssue {
      description
      issueDate
      slug
      highlights {
        title
        pageNumber
        images {
          main_141x106_141 {
            url
          }
          main_141x106_282 {
            url
          }
          main_141x106_322 {
            url
          }
          main_141x106_644 {
            url
          }
          main_141x106_900 {
            url
          }
        }
      }
      images {
        cover_321x446_321 {
          url
        }
        cover_321x446_642 {
          url
        }
      }
    }
  }
`

export default createQuery
